import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import creditcardupdateApiController from "services/creditcardupdate.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";

const creditCardErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const CreditCardStoreApi = createAsyncThunk("creditcard/create", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await creditcardupdateApiController
      .create(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "create"))
      .catch((error) => HandleError(thunkAPI, error, "create"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});


export const creditcardDetailApi = createAsyncThunk("creditcard/view", async (formValues, thunkAPI) => {
  try {
    const resposedata = await creditcardupdateApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "creditcarddetail"))
      .catch((error) => HandleError(thunkAPI, error, "creditcarddetail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const runCreditCardRequest = async (request, responseType, thunkAPI) => {
  try {
    return await request()
      .then((response) => HandleResponse(thunkAPI, response, responseType))
      .catch((error) => HandleError(thunkAPI, error, responseType));
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || error?.toString();
    return thunkAPI.rejectWithValue(message);
  }
};

export const creditcardListApi = createAsyncThunk("creditcard/list", (values, thunkAPI) => (
  runCreditCardRequest(() => creditcardupdateApiController.list(values), "creditcardlist", thunkAPI)
));

export const creditcardReconcileSubscriptionApi = createAsyncThunk("creditcard/reconcileSubscriptions", (values, thunkAPI) => (
  runCreditCardRequest(() => creditcardupdateApiController.reconcileSubscriptionCards(values), "creditcardreconcile", thunkAPI)
));

export const creditcardStartSetupApi = createAsyncThunk("creditcard/startSetup", (values, thunkAPI) => (
  runCreditCardRequest(() => creditcardupdateApiController.startSetup(values), "creditcardsetup", thunkAPI)
));

export const creditcardConfirmSetupApi = createAsyncThunk("creditcard/confirmSetup", (values, thunkAPI) => (
  runCreditCardRequest(() => creditcardupdateApiController.confirmSetup(values), "creditcardconfirmsetup", thunkAPI)
));

export const CreditCardUpdateApi = createAsyncThunk("creditcard/update", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await creditcardupdateApiController
      .update(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "update"))
      .catch((error) => HandleError(thunkAPI, error, "update"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

// export const creditcardDeleteApi = createAsyncThunk("creditcard/delete", async (formValues, thunkAPI) => {
//     try {
//       const resposedata = await creditcardupdateApiController
//         .deleted(formValues, thunkAPI)
//         .then((response) => HandleResponse(thunkAPI, response, "delete"))
//         .catch((error) => HandleError(thunkAPI, error, "delete"));
//       return resposedata;
//     } catch (error) {
//       const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   });

const initialState = {
  isCreditCardUpdates: [],
  isCreditCardUpdatesError: "",
  isCreditCardDetailData: "",
  isCreditCardDetailDataError: "",
  isCreditCardViewData: "",
  isCreditCardViewDataError: "",
  isCreditCardListData: [],
  savedCardsClientId: null,
  savedCardsRequestId: null,
  isCreditCardListDataError: "",
  isCreditCardUpdateError: "",
  isApiStatus: {
    CreditCardStoreApi: "",
    CreditCardUpdateApi: "",
    creditcardDeleteApi: "",
    creditcardDetailApi: "",
    creditcardListApi: "",
    creditcardStartSetupApi: "",
    creditcardConfirmSetupApi: "",
  }
}

export const creditcardSlice = createSlice({
  name: "creditcard",
  initialState,
  reducers: {
    reset: () => initialState,

  },
  extraReducers: (builder) => {
    builder
      .addCase(CreditCardStoreApi.pending, (state) => {
        state.isCreditCardUpdatesError = "";
        state.isApiStatus = { ...state.isApiStatus, CreditCardStoreApi: "loading" };
      })
      .addCase(CreditCardStoreApi.fulfilled, (state, action) => {
        if (state.isCreditCardUpdates && state.isCreditCardUpdates.data) {
          state.isCreditCardUpdates.data = [action.payload, ...state.isCreditCardUpdates.data];
        } else {
          state.isCreditCardUpdates = { data: [action.payload] };
        }
        state.isApiStatus = { ...state.isApiStatus, CreditCardStoreApi: "succeeded" };
        state.isCreditCardUpdatesError = "";
      })
      .addCase(CreditCardStoreApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, CreditCardStoreApi: "failed" };
        state.isCreditCardUpdatesError = creditCardErrorMessage(action, "Unable to save the credit card.");
      })
      .addCase(creditcardDetailApi.pending, (state) => {
        state.isCreditCardViewDataError = "";
        state.isApiStatus = { ...state.isApiStatus, creditcardDetailApi: "loading" };
      })
      .addCase(creditcardDetailApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, creditcardDetailApi: "succeeded" };
        state.isCreditCardViewData = action.payload;
        state.isCreditCardViewDataError = "";
      })
      .addCase(creditcardDetailApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, creditcardDetailApi: "failed" };
        state.isCreditCardViewDataError = creditCardErrorMessage(action, "Unable to load credit-card details.");
      })
      .addCase(creditcardListApi.pending, (state, action) => {
        state.savedCardsClientId = String(action.meta.arg?.client_id || "");
        state.savedCardsRequestId = action.meta.requestId;
        state.isCreditCardListData = [];
        state.isCreditCardListDataError = "";
        state.isApiStatus = { ...state.isApiStatus, creditcardListApi: "loading" };
      })
      .addCase(creditcardListApi.fulfilled, (state, action) => {
        if (state.savedCardsRequestId !== action.meta?.requestId) return;
        state.isCreditCardListData = action.payload;
        state.isCreditCardListDataError = "";
        state.isApiStatus = { ...state.isApiStatus, creditcardListApi: "succeeded" };
      })
      .addCase(creditcardListApi.rejected, (state, action) => {
        if (state.savedCardsRequestId !== action.meta?.requestId) return;
        state.isCreditCardListDataError = creditCardErrorMessage(action, "Unable to load saved cards.");
        state.isApiStatus = { ...state.isApiStatus, creditcardListApi: "failed" };
      })
      .addCase(creditcardReconcileSubscriptionApi.pending, (state, action) => {
        state.savedCardsClientId = String(action.meta.arg?.client_id || "");
        state.savedCardsRequestId = action.meta.requestId;
        state.isCreditCardListData = [];
        state.isCreditCardListDataError = "";
        state.isApiStatus = { ...state.isApiStatus, creditcardListApi: "loading" };
      })
      .addCase(creditcardReconcileSubscriptionApi.fulfilled, (state, action) => {
        if (state.savedCardsRequestId !== action.meta?.requestId) return;
        state.isCreditCardListData = action.payload;
        state.isCreditCardListDataError = "";
        state.isApiStatus = { ...state.isApiStatus, creditcardListApi: "succeeded" };
      })
      .addCase(creditcardReconcileSubscriptionApi.rejected, (state, action) => {
        if (state.savedCardsRequestId !== action.meta?.requestId) return;
        // The profile falls back to the read-only list. Keep the loading
        // boundary until that request settles; never display provider errors.
        state.isCreditCardListDataError = "";
      })
      .addCase(CreditCardUpdateApi.pending, (state) => {
        state.isCreditCardUpdateError = "";
        state.isApiStatus = { ...state.isApiStatus, CreditCardUpdateApi: "loading" };
      })
      .addCase(CreditCardUpdateApi.fulfilled, (state, action) => {
        const { id, ...changes } = action.payload;
        const existingData = state.isCreditCardUpdates && state.isCreditCardUpdates.data && state.isCreditCardUpdates.data.find((event) => event.id === id);
        if (existingData) {
          Object.keys(changes).map((keyName) => {
            existingData[keyName] = changes[keyName];
          });
        }
        state.isApiStatus = { ...state.isApiStatus, CreditCardUpdateApi: "succeeded" };
        state.isCreditCardUpdateError = "";
      })
      .addCase(CreditCardUpdateApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, CreditCardUpdateApi: "failed" };
        state.isCreditCardUpdateError = creditCardErrorMessage(action, "Unable to update the credit card.");
      });
  },
});

export const { reset } = creditcardSlice.actions;
export default creditcardSlice.reducer;
